import { css } from "../../css/util.compose-css";

import { units } from "../units";

export const hr = css`
  margin: 0;
  height: ${units.px(1)};
  border: none;
`;
